exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#anar[data-v-ffe43e08] {\n  -webkit-mask-image: linear-gradient(0deg, transparent 25px, red 75px);\n}\n@media (min-width: 768px) {\n#anar[data-v-ffe43e08] {\n    -webkit-mask-image: linear-gradient(0deg, transparent 50px, red 160px);\n}\n}\n#chive[data-v-ffe43e08] {\n  -webkit-mask-image: linear-gradient(180deg, transparent 11px, red 75px);\n}\n@media (min-width: 768px) {\n#chive[data-v-ffe43e08] {\n    -webkit-mask-image: linear-gradient(180deg, transparent 4px, red 140px);\n}\n}", ""]);

// exports
